import { useEditor } from '../store/useEditor'
import { IconFit, IconMinus, IconPlus } from './icons'

/**
 * Zoom and fit. Nothing else.
 *
 * The Move tool was here and it is gone. Panning is not a mode you enter and
 * leave any more: scroll moves the photograph, space and drag moves it, and
 * neither can push it out of the frame now that the view is clamped. A button
 * whose whole job was to make a gesture safe is not needed once the gesture is
 * safe, and reported as such: I do not see a purpose for being able to move
 * the picture around.
 *
 * Deliberately not a professional-software control cluster. Every item here is
 * labeled or universally understood, because the person holding the tablet
 * installs lights for a living and should never have to guess what a button
 * does.
 */
export default function CanvasControls({
  zoom,
  onZoom,
  onFit,
}: {
  zoom: number
  onZoom: (factor: number) => void
  onFit: () => void
}) {
  const hasPhoto = useEditor((s) => !!s.doc.photo)

  if (!hasPhoto) return null

  return (
    <div className="canvas-controls">
      <button className="cc" onClick={() => onZoom(1 / 1.25)} title="Zoom out">
        <IconMinus size={16} />
      </button>
      {/*
        A READOUT, NOT A BUTTON.

        It was a button, and it did exactly what Fit does, two controls along.
        Two buttons that look different and do the same thing is worse than
        either one alone: it makes the bar look like it has more in it than it
        has, and it makes a person wonder which one they wanted.
      */}
      <span className="cc cc-zoom" aria-hidden="true">
        {Math.round(zoom * 100)}%
      </span>
      <button className="cc" onClick={() => onZoom(1.25)} title="Zoom in">
        <IconPlus size={16} />
      </button>

      <span className="cc-sep" />

      <button className="cc cc-wide" onClick={onFit} title="Fit the house to the view">
        <IconFit size={16} />
        <span>Fit</span>
      </button>
    </div>
  )
}
